<template>
  <div class="tinymce-editor">
    <editor v-model="myValue"
            id="tinymceEditor"
            :init="editorType !== 'base64' ? init : initBase64"
            :disabled="disabled"
            @onClick="onClick">
    </editor>
  </div>
</template>
<script>
  import tinymce from 'tinymce/tinymce'
  import Editor from '@tinymce/tinymce-vue'
  import Cookies from 'js-cookie';
  import storeLocal from 'store'
  import { Message } from 'element-ui'
  import {getConfigLanguage} from "@/utils/utils";
  import 'tinymce/themes/silver/theme'
  import 'tinymce/icons/default/icons'
  // 编辑器插件plugins
  // 更多插件参考：https://www.tiny.cloud/docs/plugins/
  import 'tinymce/plugins/image'// 插入上传图片插件
  import 'tinymce/plugins/media'// 插入视频插件
  import 'tinymce/plugins/table'// 插入表格插件
  import 'tinymce/plugins/lists'// 列表插件
  import 'tinymce/plugins/wordcount'// 字数统计插件
  import 'tinymce/plugins/link'// 链接插件
  import 'tinymce/plugins/code' //代码块插件
  import '@/static/tinymce/plugin/axupimgs/plugin.js'
  export default {
    name: "tinymce-editor",
    components: {
      Editor
    },
    props: {
      editorType: {
        type: String,
        default: ''
      },
      value: {
        type: String,
        default: ''
      },
      // 基本路径，默认为空根目录，如果你的项目发布后的地址为目录形式，
      // 即abc.com/tinymce，baseUrl需要配置成tinymce，不然发布后资源会找不到
      baseUrl: {
        type: String,
        default: '/static'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      plugins: {
        type: [String, Array],
        default: 'lists image media table wordcount link code axupimgs formatpainter'
      },
      toolbar: {
        type: [String, Array],
        default: 'undo redo | fontselect | fontsizeselect | bold italic forecolor backcolor formatpainter | lineheight alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists image table | link code | axupimgs'
      }
    },
    data () {
      const imageHandler = (blobInfo, succFun, failure) => {
        var xhr, formData;
        var file = blobInfo.blob();//转化为易于理解的file对象
        console.log(`file:$`)
        console.log(file)
        xhr = new XMLHttpRequest();
        xhr.withCredentials = false;
        xhr.open('POST', '/xmail/wm/v1/file/innerFileUpload' + storeLocal.get('Pwm-urlParams'));
        xhr.onload = function() {
            if (xhr.status !== 200) {
              failure('上传失败！');
              return;
            }
            var json = JSON.parse(xhr.responseText);
            succFun(json.data.location);
        };
        formData = new FormData();
        formData.append('file', file, file.name );
        xhr.send(formData);
      };
      const getLangType = () => {
        const configLanguage = getConfigLanguage();
        let langType = configLanguage || 'cn';
        let lang = '';
        switch (langType) {
          case 'cn':
            lang = 'zh_CN';
            break;
          case 'en':
            lang = 'en';
            break;
          case 'hk':
            lang = 'zh_HK';
            break;
        }
        return lang;
      };
      const vm = this; // 捕获 Vue 实例的引用
      return {
        init: {
          language_url: `${this.baseUrl}/tinymce/langs/${getLangType()}.js`,
          language: getLangType(),
          skin_url: `${this.baseUrl}/tinymce/skins/ui/oxide`,
          content_css: `${this.baseUrl}/tinymce/skins/content/default/content.css`,
          // skin_url: `${this.baseUrl}/tinymce/skins/ui/oxide-dark`, // 暗色系
          // content_css: `${this.baseUrl}/tinymce/skins/content/dark/content.css`, // 暗色系
          height: (document.documentElement.clientHeight || document.body.clientHeight) - 350,
          default_link_target: "_blank",
          auto_focus : true,
          statusbar: false,
          convert_urls: false,
          plugins: this.plugins,
          toolbar: this.toolbar,
          branding: false,
          menubar: false,
          // 添加扩展插件
          external_plugins: {
            powerpaste: `${this.baseUrl}/powerpaste/plugin.min.js`,
            formatpainter: `${this.baseUrl}/formatpainter/plugin.min.js`,
          },
          powerpaste_word_import: 'merge', // 参数 propmt, merge, clear
          powerpaste_html_import: 'merge', // 参数 propmt, merge, clear
          powerpaste_allow_local_images: true,
          lineheight_formats: '1 1.5 1.75 2 3 4 5',
          font_formats: `${this.$i18n.t('wm_lang_971f54')}='微软雅黑';${this.$i18n.t('wm_lang_71b068')}='宋体';${this.$i18n.t('wm_lang_e0b004')}='黑体';${this.$i18n.t('wm_lang_2cff3b')}='仿宋';${this.$i18n.t('wm_lang_02aaf1')}='楷体';${this.$i18n.t('wm_lang_168dfa')}='隶书';${this.$i18n.t('wm_lang_68018f')}='幼圆';Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings`,
          fontsize_formats: "10px 11px 12px 14px 16px 18px 20px 24px 36px",
          setup : function(ed)
          {
            ed.on('init', function(ed)
            {
              let configSetting = storeLocal.get('Pwm-configSetting');
              this.getDoc().body.style.fontSize = configSetting.deliverSetting.fontSize+'px';
              this.getDoc().body.style.fontFamily = configSetting.deliverSetting.fontName;
              // ed.target.editorCommands.execCommand("fontName", false, configSetting.deliverSetting.fontName);
              // ed.target.editorCommands.execCommand("fontSize", false, configSetting.deliverSetting.fontSize+'px');
            });
          },
          // block_unsupported_drop: false,
          // images_upload_url: '/xmail/wm/v1/file/innerFileUpload' + storeLocal.get('Pwm-urlParams'),
          images_upload_base_path: '',
          file_picker_callback: function (callback, value, meta) {
            console.log('meta')
            console.log(meta)
            //文件分类
            let filetype='.pdf, .txt, .zip, .rar, .7z, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .mp3, .mp4';
            //后端接收上传文件的地址
            let upurl='/demo/upfile.php';
            //为不同插件指定文件类型及后端地址
            switch(meta.filetype){
              case 'image':
                filetype='.jpg, .jpeg, .png, .gif';
                upurl='/xmail/wm/v1/file/innerFileUpload' + storeLocal.get('Pwm-urlParams');
                break;
              case 'media':
                filetype='.mp3, .mp4';
                upurl='/xmail/wm/v1/file/innerFileUpload' + storeLocal.get('Pwm-urlParams');
                break;
              case 'file':
              default:
            }
            //模拟出一个input用于添加本地文件
            let input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', filetype);
            input.click();
            input.onchange = function() {
              let file = this.files[0];
              if(file.size > 1024 * 1024) {
                Message(vm.$i18n.t('custom_lang_0059'));
                return;
              }

              let xhr, formData;
              // console.log(file.name);
              xhr = new XMLHttpRequest();
              xhr.withCredentials = false;
              xhr.open('POST', upurl);
              xhr.onload = function() {
                let json;
                if (xhr.status !== 200) {
                  // failure('HTTP Error: ' + xhr.status);
                  return;
                }
                json = JSON.parse(xhr.responseText);
                if (!json || typeof json.data.location !== 'string') {
                  // failure('Invalid JSON: ' + xhr.responseText);
                  return;
                }
                callback(json.data.location);
              };
              formData = new FormData();
              formData.append('file', file, file.name );
              xhr.send(formData);
            };
          },
          file_picker_types: 'image media',
          // 此处为图片上传处理函数，这个直接用了base64的图片形式上传图片，
          // 如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
          // images_upload_url: '/xmail/wm/v1/file/innerFileUpload' + storeLocal.get('Pwm-urlParams'),
          images_upload_handler: (blobInfo, success, failure) => {
            const isSizeLimit = blobInfo.blob().size / 1024 / 1024 < 1;
            if (!isSizeLimit) {
              failure(this.$i18n.t('custom_lang_0059'), Message, blobInfo.blob().name);
              // failure(Message, blobInfo.blob().name);
            } else {
              imageHandler(blobInfo, success, failure)
            }
          }
        },
        initBase64: {
          language_url: `${this.baseUrl}/tinymce/langs/${getLangType()}.js`,
          language: getLangType(),
          skin_url: `${this.baseUrl}/tinymce/skins/ui/oxide`,
          content_css: `${this.baseUrl}/tinymce/skins/content/default/content.css`,
          // skin_url: `${this.baseUrl}/tinymce/skins/ui/oxide-dark`, // 暗色系
          // content_css: `${this.baseUrl}/tinymce/skins/content/dark/content.css`, // 暗色系
          height: (document.documentElement.clientHeight || document.body.clientHeight) - 350,
          default_link_target: "_blank",
          auto_focus : true,
          statusbar: false,
          convert_urls: false,
          plugins: this.plugins,
          // toolbar: this.toolbar,
          toolbar: 'undo redo | fontselect | fontsizeselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists image table | link code',
          branding: false,
          menubar: false,
          font_formats: `${this.$i18n.t('wm_lang_971f54')}='微软雅黑';${this.$i18n.t('wm_lang_71b068')}='宋体';${this.$i18n.t('wm_lang_e0b004')}='黑体';${this.$i18n.t('wm_lang_2cff3b')}='仿宋';${this.$i18n.t('wm_lang_02aaf1')}='楷体';${this.$i18n.t('wm_lang_168dfa')}='隶书';${this.$i18n.t('wm_lang_68018f')}='幼圆';Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings`,
          fontsize_formats: "10px 11px 12px 14px 16px 18px 20px 24px 36px",
          setup : function(ed)
          {
            ed.on('init', function(ed)
            {
              // this.getDoc().body.style.fontSize = '12px';
              // this.getDoc().body.style.fontFamily = '宋体';
              ed.target.editorCommands.execCommand("fontName", false, '宋体');
              ed.target.editorCommands.execCommand("fontSize", false, '12px');
            });
          },
          // block_unsupported_drop: false,
          // images_upload_url: '/xmail/wm/v1/file/innerFileUpload' + storeLocal.get('Pwm-urlParams'),
          images_upload_base_path: '',
          file_picker_types: 'image media',
          // 此处为图片上传处理函数，这个直接用了base64的图片形式上传图片，
          // 如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
          images_upload_handler: (blobInfo, success, failure) => {
            // const img = 'data:image/jpeg;base64,' + blobInfo.base64()
            // success(img)
            const isSizeLimit = blobInfo.blob().size / 1024 / 1024 < 1;
            if (!isSizeLimit) {
              failure(this.$i18n.t('custom_lang_0059'), Message, blobInfo.blob().name);
              // failure(Message, blobInfo.blob().name);
            } else if (blobInfo.base64) {
              const img = 'data:image/jpeg;base64,' + blobInfo.base64()
              success(img)
            } else {
              imageHandler(blobInfo, success, failure)
            }
          }
        },
        myValue: this.value
      }
    },
    mounted () {
      console.log('--------------tinymce-editor mounted---------------')
      // tinymce.init({
      //   //设置默认字体字号
      //   // setup: function(editor) {
      //   //   editor.on('init', function(ed) {
      //   //     console.log(ed);
      //   //     // ed.target.editorCommands.execCommand("fontName", false, "微软雅黑");
      //   //     // ed.target.editorCommands.execCommand("fontSize", false, "18px");
      //   //     this.getDoc().body.style.fontSize = "18px";
      //   //     this.getDoc().body.style.fontFamily = "楷体";
      //   //   });
      //   // }
      // });
    },
    methods: {
      // 添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
      // 需要什么事件可以自己增加
      onClick (e) {
        // this.$emit('onClick', e, tinymce)
      },
      // 可以添加一些自己的自定义事件，如清空内容
      clear () {
        this.myValue = ''
      }
    },
    watch: {
      value (newValue) {
        this.myValue = newValue
      },
      myValue (newValue) {
        this.$emit('input', newValue)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/editor/tinymce-editor.vue